import { NextRouter } from 'next/router'
import { execute } from '@tutorabc/webview-jsbridge'

// Libs
import handleRoutePushWithQuery from '@/methods/url/handleRoutePushWithQuery'
import { LIVE_SOURCE_QUERY, LIVE_TRACK_EVENT, liveSourceFromPathname, trackLiveEvent } from '@/methods/liveTracking'

// constants
import { isClientSideShopApp } from '@/utils/navigator'
import { ROOM_LIVE_TYPE, ROOM_MODE } from '@/constants/liveRoom'
import { ROUTE_PATH } from '@/constants/routePath'
import { BRIDGE_HANDLER } from '@/constants/bridgeHandler'

interface IGoToLiveRoom {
  router: NextRouter
  roomId: string
  liveType: number
  liveSourceType?: number
  roomMode?: number
  source?: string // 流量來源；不帶時依目前頁面判斷（首頁、直播列表、搜尋…）
}

// 競標房走整合 live-chat-kit 的 /live/auction/[roomId]，一般房維持 /live/[roomId]
export const getLiveRoomPath = ({ roomId, roomMode }: { roomId: string; roomMode?: number }) =>
  roomMode === ROOM_MODE.AUCTION ? `${ROUTE_PATH.LIVE}/auction/${roomId}` : `${ROUTE_PATH.LIVE}/${roomId}`

export const goToLiveRoom = ({ router, roomId, liveType = ROOM_LIVE_TYPE.DEFAULT, liveSourceType, roomMode, source }: IGoToLiveRoom) => {
  // 點直播封面／卡片：記封面點擊，並把來源帶進直播間網址，進房時記成流量來源
  const src = source || liveSourceFromPathname(router.pathname)
  trackLiveEvent({ type: LIVE_TRACK_EVENT.COVER_CLICK, roomId, source: src })
  const isLiveOrFuture = liveType === ROOM_LIVE_TYPE.CURRENT || liveType === ROOM_LIVE_TYPE.FUTURE
  if (isClientSideShopApp && isLiveOrFuture) {
    execute({
      handlerName: BRIDGE_HANDLER.OPEN_ROOM,
      data: {
        id: roomId,
        liveType,
        liveSourceType,
      },
    })
  } else {
    handleRoutePushWithQuery({ router, pathname: getLiveRoomPath({ roomId, roomMode }), query: { [LIVE_SOURCE_QUERY]: src } })
  }
}
